export enum INCOMPLETE_SIGNUP_DESTINATION_REASON {
  NO_ACCOUNTS = 'no_accounts',
  STORED_PROGRESS = 'stored_progress',
  MULTIPLE_INCOMPLETE_ACCOUNTS = 'multiple_incomplete_accounts',
  CANCELLED_SUBSCRIPTION = 'cancelled_subscription',
  RETURN_URL = 'return_url',
  RESUME_STEP = 'resume_step',
  PLAN_PAYMENT = 'plan_payment',
  DEFAULT_PLANS = 'default_plans',
}
